import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import PropTypes from 'prop-types';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Utils from '../../utils';
import audio from '../../utils/audio';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
/** @typedef {import('../../api/Constants').InboxMessagesResponse} InboxMessagesResponse */

/** @typedef {import('../../api/Constants').InboxCategory} InboxCategory */

/** @typedef {import('../../api/Constants').InboxMessagePreview} InboxMessagePreview */

/** @typedef {import('../../api/Constants').InboxMessageDetails} InboxMessageDetails */

/** @typedef {import('../../api/Constants').RewardInfo} RewardInfo */

var Messages = /*#__PURE__*/function (_Component) {
  _inherits(Messages, _Component);

  var _super = _createSuper(Messages);

  function Messages(props) {
    var _this;

    _classCallCheck(this, Messages);

    _this = _super.call(this, props);

    _this._onInboxUpdateHandler = function () {
      var activeTab = _this.state.activeTab;

      _this.fetchMessages(activeTab);
    };

    _this.fetchMessages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _useFeatureFlags, hasFeature, messages, ImagesCdnBaseUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
              _context.prev = 1;
              _context.next = 4;
              return InboxMessagesProvider.getMessages();

            case 4:
              messages = _context.sent;
              ImagesCdnBaseUrl = _this.props.assetsUrls.ImagesCdnBaseUrl;

              if (!hasFeature(FE_SNEAK_PEEK)) {
                messages = messages.filter(function (item) {
                  return item.action && item.action.search('sneakPeek:') === -1 || !item.action;
                });
              }

              _this.setState({
                imagesCdnBaseUrl: ImagesCdnBaseUrl
              });

              _this.setState({
                messages: messages
              });

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    _this.fetchMessageDetails = function (id) {
      audio.onClick();
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MESSAGE_ID, id));

      _this.setState({
        activeMessageID: id
      });
    };

    _this._tabSelectHandler = function (id) {
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MESSAGE_INBOX_CATEGORY, id));

      _this.setState({
        activeTab: id
      });
    };

    _this._messageDetailsHandler = function (id) {
      _this.fetchMessageDetails(id);
    };

    _this._backHandler = function () {
      audio.onClick();
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MESSAGE_ID, undefined));

      _this.setState({
        activeMessageID: undefined
      });
    };

    _this.state = {
      sectionedMessages: [],
      messages: [],
      imagesCdnBaseUrl: '',
      activeTab: QueryParamProxy.findParam(RouteParamConstants.PARAM_MESSAGE_INBOX_CATEGORY, ''),
      activeMessageID: QueryParamProxy.findParam(RouteParamConstants.PARAM_MESSAGE_ID, undefined)
    };
    return _this;
  }

  _createClass(Messages, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state = this.state,
          activeMessageID = _this$state.activeMessageID,
          activeTab = _this$state.activeTab;

      if (activeMessageID !== -1) {
        this.fetchMessageDetails(activeMessageID);
      }

      this.fetchMessages(activeTab);
      InboxMessagesProvider.on(InboxMessagesProvider.EVENTKEY, this._onInboxUpdateHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state2 = this.state,
          activeMessageID = _this$state2.activeMessageID,
          activeTab = _this$state2.activeTab;

      if (prevState.activeMessageID !== activeMessageID) {
        if (!Utils.isEmpty(activeMessageID)) {
          this.fetchMessageDetails(activeMessageID);
        } else {
          this.fetchMessages(activeTab);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _QueryParamProxy$setQ4;

      QueryParamProxy.setQueryParams((_QueryParamProxy$setQ4 = {}, _defineProperty(_QueryParamProxy$setQ4, RouteParamConstants.PARAM_MESSAGE_ID, undefined), _defineProperty(_QueryParamProxy$setQ4, RouteParamConstants.PARAM_MESSAGE_INBOX_CATEGORY, undefined), _QueryParamProxy$setQ4));
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      return render(_objectSpread(_objectSpread({}, this.state), {}, {
        tabSelectHandle: this._tabSelectHandler,
        messageDetailsHandle: this._messageDetailsHandler,
        backHandle: this._backHandler
      }));
    }
  }]);

  return Messages;
}(Component);

export { Messages as default };
Messages.propTypes = {
  render: PropTypes.func.isRequired
};